import register from 'ShopUi/app/registry';
import { importWithFallback } from 'PyzShopUi/scripts/utils/importWithFallback';

export default register('cart-code-form', () =>
    importWithFallback(
        /* webpackMode: "lazy" */
        () => import('./cart-code-form')
        ),
);
